export default {
  setComments(state, comments) {
    state.comments = comments;
  },
  setComment(state, comment) {
    state.comment = comment;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  }
};
